<template>
  <div class="papers">
    <!--<a class="item box" v-for="item in list" :key="_.get(item, 'id')" v-bind:href="_.invoke(item, 'link')">-->
    <v-slider data="paper"/>

<!--    <iframe width="100%" height="500" src="https://www.youtube-nocookie.com/embed/oCcCr2l6gHo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
<!--    <br/>-->
    
    <div v-for="item in list" :key="item.id">
      <div v-if="isShow(item)" class="item box">
        <router-link v-bind:to="item.link()">
          <div :class="item.published ? '' : 'draft'">
            <div class="imageContainer"><v-img v-if="item.image()" :src="item.image()"/></div>
            <title class="color">{{item.title}}</title>
            <content>{{item.extract()}}</content>
          </div>
        </router-link>
        <div class="date">{{formatDate(item.created)}}</div>
        <social-sharing :url="getUrl(item)"
                        :title="getTitle(item)"
                        description="Site officiel de l'Avenir Sport. Club de football de Saint-Pierre-Montlimart et de Montrevault"
                        hashtags="avenirsport"
                        twitter-user=""
                        inline-template
                        class="social">
          <div>
            <network network="facebook">
              <v-icon class="pointer m8" name="brands/facebook"/>
            </network>
            <network network="twitter">
              <v-icon class="pointer m8" name="brands/twitter"/>
            </network>
          </div>
        </social-sharing>
      </div>  
    </div>
    <infinite-loading @infinite="fetch" :distance="distance" ref="infiniteLoading"></infinite-loading>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import PaperService from '../../services/paper.service'
  import moment from 'moment'
  import helper from '../../helper'

  export default {
    context: {
      auth: {
        type: Object,
        default: null
      }
    },
    name: 'Papers',
    props: {},
    computed: {},
    data() {
      return {
        distance: 100,
        list: []
      }
    },
    mounted() {
      helper.push(this.list, PaperService.getPapers())
    },
    updated() {
      this.$nextTick(() => {
        this.$refs.infiniteLoading.attemptLoad();
      });
    },
    methods: {
      getUrl(paper) {
        return PaperService.getShareLink(paper)  
      },
      getTitle(paper) {
        return PaperService.getShareTitle(paper)
      },
      formatDate(date) {
        return moment(date).format('DD-MM-YY')
      },
      isShow(item) {
        /* display if published or admin or owner*/
        return PaperService.isShow(item)
      },
      fetch: function ($state) {
        //console.log("papers fetch")
        PaperService.fetch()
          .then(papers => {
            if (_.isEmpty(papers)) return $state.complete();
            helper.push(this.list, papers);
          })
      }
    },
    components: {
      InfiniteLoading,
    }
  }
</script>

<style scoped lang="stylus">
  .papers
    display grid
  .item
    position relative
    display table
    text-decoration none
    padding 10px
    width 100%
    box-sizing border-box
    .imageContainer
      max-height 400px
      overflow hidden
      img
        float left
        width 100%
        max-width 100%
        height auto
        padding-bottom 10px
        /*max-height 400px*/
    title
      display block
      text-align center
      padding 15px 0 15px
      text-transform uppercase
      font-family 'Passion One'
      font-size larger
    content
      display block
      margin-bottom 20px
      min-height 100px
      /*min-width 700px*/
      /*@media screen and (max-width: 1200px)*/
        /*min-width 700px*/
    .draft
      color #ddd !important
      title
        color #bddeff !important
    .date
      position absolute
      bottom 8px
      right 10px
      font-size smaller
    .social
      position absolute
      bottom 5px
      right 70px
      font-size smaller
</style>
